import { useTheme } from '@mui/material';

export default function Logo({ className, style, svgcolor, width = '200px', showText = true }) {
    const theme = useTheme();
    const color = svgcolor || (theme.palette.mode === 'dark' ? 'white' : 'black');

    return (
        <svg
            className={className}
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
            stroke={color}
            fill={color}
            style={{
                width: width, 
                ...style
            }}
        >
            {/* Deblo stabla */}
            <line x1="100" y1={showText ? "150" : "180"} x2="100" y2="50" strokeWidth="8" strokeLinecap="round" />

            {/* Glavni čvor (središnji krug) */}
            <circle cx="100" cy="50" r="8" />

            {/* Prva razina grana */}
            <line x1="100" y1="80" x2="60" y2="40" strokeWidth="4" strokeLinecap="round" />
            <circle cx="60" cy="40" r="6" />

            <line x1="100" y1="80" x2="140" y2="40" strokeWidth="4" strokeLinecap="round" />
            <circle cx="140" cy="40" r="6" />

            {/* Druga razina grana */}
            <line x1="60" y1="40" x2="40" y2="20" strokeWidth="3" strokeLinecap="round" />
            <circle cx="40" cy="20" r="5" />

            <line x1="60" y1="40" x2="80" y2="20" strokeWidth="3" strokeLinecap="round" />
            <circle cx="80" cy="20" r="5" />

            <line x1="140" y1="40" x2="120" y2="20" strokeWidth="3" strokeLinecap="round" />
            <circle cx="120" cy="20" r="5" />

            <line x1="140" y1="40" x2="160" y2="20" strokeWidth="3" strokeLinecap="round" />
            <circle cx="160" cy="20" r="5" />

            {/* Donje grane */}
            <line x1="100" y1="100" x2="40" y2="80" strokeWidth="4" strokeLinecap="round" />
            <circle cx="40" cy="80" r="6" />

            <line x1="100" y1="100" x2="160" y2="80" strokeWidth="4" strokeLinecap="round" />
            <circle cx="160" cy="80" r="6" />

            {/* Grančice na donjim granama */}
            <line x1="40" y1="80" x2="30" y2="60" strokeWidth="3" strokeLinecap="round" />
            <circle cx="30" cy="60" r="5" />

            <line x1="40" y1="80" x2="50" y2="60" strokeWidth="3" strokeLinecap="round" />
            <circle cx="50" cy="60" r="5" />

            <line x1="160" y1="80" x2="150" y2="60" strokeWidth="3" strokeLinecap="round" />
            <circle cx="150" cy="60" r="5" />

            <line x1="160" y1="80" x2="170" y2="60" strokeWidth="3" strokeLinecap="round" />
            <circle cx="170" cy="60" r="5" />

            {/* Tekst "EUDR API" */}
            {showText && (
                <text x="100" y="180" fontFamily="Courier New, monospace" fontSize="20" textAnchor="middle">EUDR API</text>
            )}
        </svg>
    );
} 